import React from "react";
import { CgArrowsExchangeAlt } from "react-icons/cg";
import { FiArrowUpRight, FiArrowDownRight } from "react-icons/fi";

const CurrencyCard = ({ currencyPair, rate, changePips, changePercent }) => {
  // กำหนดสีของวงกลม (สีเขียวสำหรับกราฟขึ้น, สีแดงสำหรับกราฟลง)
  const color = changePips > 0 ? "green" : "red";
  const lightColor = changePips > 0 ? "#e2edea" : "#FF6666";

  return (
    <div className="currency-card" style={styles.card}>
      <div
        style={{
          ...styles.circle,
          backgroundColor: lightColor,
        }}
      >
        {changePips > 0 ? (
          <FiArrowUpRight size={24} color={color} />
        ) : (
          <FiArrowDownRight size={24} color={color} />
        )}
      </div>
      <div style={styles.left}>
        <h3 style={styles.title}>
          {currencyPair.slice(0, 3)}
          <CgArrowsExchangeAlt
            size={24}
            style={{ marginRight: 4, marginLeft: 4 }}
            color={"#6D7270"}
          />
          {currencyPair.slice(3)}
        </h3>
      </div>
      <div style={styles.right}>
        <p style={{ color: color }}>{changePercent}</p>
        <p style={{ marginTop: 6, color: "#6D7270" }}>
          {Number(rate).toFixed(2)}$
        </p>
      </div>
    </div>
  );
};

// สไตล์การ์ด
const styles = {
  card: {
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "16px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#fff",
    margin: "10px",
    display: "flex",
    alignItems: "center",
    color: "black",
    cursor: "pointer", // เปลี่ยนเคอร์เซอร์เป็น pointer เมื่อ hover
    transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
  },
  cardHover: {
    transform: "scale(1.05)", // ขยายขนาดเล็กน้อยเมื่อ hover
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)", // เพิ่มเงาให้ดูมีมิติ
  },
  circle: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    marginRight: 12,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
  left: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
  right: {
    textAlign: "right",
  },
};

export default CurrencyCard;
